<template>
  <div class="footer">
    <h2>Copyright © 2018-2021 www.power.com All Rights Reserved.</h2>
  </div>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped lang="less">
.footer {
  height: 100%;
  color: aqua;
  background: url(../assets/header-background.png) no-repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
